import { render, staticRenderFns } from "./MassMessageEdit.vue?vue&type=template&id=72c74c8f&scoped=true&"
import script from "./MassMessageEdit.vue?vue&type=script&lang=ts&"
export * from "./MassMessageEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageEdit.vue?vue&type=style&index=0&id=72c74c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c74c8f",
  null
  
)

export default component.exports